import { styled } from '@elliemae/ds-system';
import { DSButtonV2 } from '@elliemae/ds-button-v2';
import { Grid } from '@elliemae/ds-grid';
import { getLeftBorderStyle, getItemBackgroundStyle } from '../../common/index.js';
import { DSLeftNavigationName, LEFT_NAVIGATION_SLOTS } from '../../constants/index.js';
import type { DSLeftNavigationT } from '../../react-desc-prop-types.js';

export const StyledFooterMenu = styled(Grid, { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.FOOTER_MENU })`
  width: 100%;
  margin-top: auto;
  background: ${(props) => props.theme.colors.neutral['000']};

  border-top: 1px solid ${(props) => props.theme.colors.neutral[100]};
`;

export const StyledFooterItem = styled(Grid, { name: DSLeftNavigationName, slot: LEFT_NAVIGATION_SLOTS.FOOTER_ITEM })<{
  expanded?: boolean;
  opened?: boolean;
  selected?: boolean;
  selectedParent?: boolean;
}>`
  position: relative;
  ${(props) => getLeftBorderStyle({ ...props })}

  min-height: 48px;
  cursor: ${(props) => (props.expanded ? 'auto' : 'pointer')};

  ${getItemBackgroundStyle}

  outline: none;

  :focus {
    &:before {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0px;
      border: 2px solid ${(props) => props.theme.colors.brand[600]};
      pointer-events: none;
    }
  }
`;

export const StyledFooterLabel = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.FOOTER_LABEL,
})<{ labelOverflow?: DSLeftNavigationT.LabelOveflowT }>`
  font-size: 11px;
  color: ${(props) => props.theme.colors.neutral[500]};
  line-height: 14px;
  word-break: ${(props) => (props.labelOverflow === 'wrapAll' ? 'break-all' : 'normal')};
`;

export const StyledFooterSeparator = styled(Grid, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.FOOTER_SEPARATOR,
})`
  height: 16px;
  width: 1px;
  background-color: ${(props) => props.theme.colors.neutral[100]};
`;

export const StyledMenuCollapse = styled(DSButtonV2, {
  name: DSLeftNavigationName,
  slot: LEFT_NAVIGATION_SLOTS.FOOTER_MENU_COLLAPSE,
})`
  padding: 0;
  margin: 0 12px;
  :focus {
    outline: 2px solid ${(props) => props.theme.colors.brand[800]};
  }
`;
